import { render, staticRenderFns } from "./ExchangeRecord.vue?vue&type=template&id=5bf57648&scoped=true"
import script from "./ExchangeRecord.vue?vue&type=script&lang=js"
export * from "./ExchangeRecord.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRecord.vue?vue&type=style&index=0&id=5bf57648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf57648",
  null
  
)

export default component.exports